var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchandFilterCanvas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11921_20869)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 0H0V11H11V0ZM8.36368 1L2.22728 7.13639L3.86365 8.77274L10 2.63635L8.36368 1ZM1.8182 7.54543L1 10L3.45457 9.18183L1.8182 7.54543Z",
    fill: "#CACACA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8757 4.33333H13.9586V8.66667C13.9586 9.21895 14.3878 9.66667 14.9172 9.66667C15.4466 9.66667 15.8757 9.21895 15.8757 8.66667V4.33333Z",
    fill: "#CACACA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 0H12V11H23V0ZM16.8343 1H13V1.66667H13.6391V8.66667C13.6391 9.40305 14.2113 10 14.9172 10C15.623 10 16.1953 9.40305 16.1953 8.66667V1.66667H16.8343V1ZM17.4734 2.5H22V3.44444H17.4734V2.5ZM17.4734 4.38889H22V5.33333H17.4734V4.38889ZM17.4734 6.27778H22V7.22222H17.4734V6.27778ZM17.4734 8.16667H22V9.11111H17.4734V8.16667Z",
    fill: "#CACACA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.46875 16.0938C7.93474 16.0938 8.3125 15.716 8.3125 15.25C8.3125 14.784 7.93474 14.4062 7.46875 14.4062C7.00276 14.4062 6.625 14.784 6.625 15.25C6.625 15.716 7.00276 16.0938 7.46875 16.0938Z",
    fill: "#CACACA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.81818 13.4091C1.61364 13.4091 1.40909 13.6136 1.40909 13.8182V21.1818C1.40909 21.3864 1.61364 21.5909 1.81818 21.5909H9.18182C9.38636 21.5909 9.59091 21.3864 9.59091 21.1818V13.8182C9.59091 13.6136 9.38636 13.4091 9.18182 13.4091H1.81818ZM9.18182 14.2273V19.9545L6.72727 17.5L5.90909 18.3182L4.68182 16.6818L1.81818 19.9545V14.2273C1.81818 14.0227 2.02273 13.8182 2.22727 13.8182H8.77273C8.97727 13.8182 9.18182 14.0227 9.18182 14.2273Z",
    fill: "#CACACA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 12H0V23H11V12ZM1 13.8438C1 13.4091 1.404 13 1.81818 13H9.18182C9.596 13 10 13.4091 10 13.8182V21.1818C10 21.596 9.59091 22 9.18182 22H1.81818C1.40909 22 1 21.596 1 21.1818V13.8438Z",
    fill: "#CACACA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 15V17H15V15H20Z",
    fill: "#CACACA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 12H12V23H23V12ZM20 14H15V15H14V17H15V18H20V20H15V19H14V20H15V21H20V20H21V15H20V14Z",
    fill: "#CACACA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 23H23V24H1V23Z",
    fill: "#CACACA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 1H24V24H23V1Z",
    fill: "#CACACA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11921_20869"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchandFilterCanvas);
export default __webpack_public_path__ + "static/media/SearchandFilterCanvas.01812c704bf4a36e0138e78aa8b202d9.svg";
export { ForwardRef as ReactComponent };